<template>
    <v-container fluid class="divs">
        <v-card>
            <v-toolbar dark color="secondary" class="white--text" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    Invoices Group
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container fluid>
                <v-form ref="form" lazy-validation>
                    <v-row>
                        <v-col cols="4">
                            <v-combobox label="Select Group" dense :items="groupCustomers" :item-text="'GroupName'"
                                :item-value="'InvGroupID'" auto-select-first v-model="group" @change="loadTabls()"></v-combobox>
                        </v-col>
                        <v-col cols="2">
                            <v-combobox v-model="customer" :items="customers" :item-text="'Name'" :item-value="'id'"
                                label="Customer" dense :rules="[v => !!v || 'Customer is required']" auto-select-first
                                append-outer-icon="mdi-account-plus" @click:append-outer="validate"></v-combobox>
                        </v-col>
                        <v-col>
                            <v-btn color="primary" small
                                @click="$store.state.groupFSC.rename = true;"><v-icon>mdi-pencil</v-icon>
                                Rename</v-btn>
                            <v-btn color="secondary" class="ml-2" small
                                @click="$store.state.groupFSC.history = true;"><v-icon>mdi-clipboard-text-clock</v-icon>
                                History</v-btn>
                            <v-btn color="secondary" small class="ml-2" @click="$store.state.groupFSC.add = true;"><v-icon>mdi-plus-circle</v-icon> Add</v-btn>
                        </v-col>
                    </v-row>
                </v-form>
                <v-tabs centered>
                    <v-tab>Customer</v-tab>
                    <v-tab>History FSC</v-tab>
                    <v-tab-item class="mx-5">
                        <v-data-table dense :headers="headers" :items="customerTable">
                            <template v-slot:item.Active="{ item }">
                                <v-icon>mdi-{{ item.Active ? 'check-circle-outline' : 'close-circle-outline' }}</v-icon>
                            </template>
                            <template v-slot:item.Action="{ item }">
                                <v-btn color="red" icon
                                    @click="deleteCustomer(item)"><v-icon>mdi-minus-circle</v-icon></v-btn>
                            </template>
                        </v-data-table>
                    </v-tab-item>
                    <v-tab-item class="mx-5">
                        <v-data-table dense :headers="groupHeader" :items="history">
                            <template v-slot:item.Action="{ item }">
                                <v-btn color="red" icon @click="deleteHistory(item)"><v-icon>mdi-delete-circle</v-icon></v-btn>
                            </template>
                        </v-data-table>
                    </v-tab-item>
                </v-tabs>
                
                <addgroup v-if="$store.state.groupFSC.add" @close="groupCustomer"></addgroup>
                <rename v-if="$store.state.groupFSC.rename" :parms="groupCustomers" @close="groupCustomer"></rename>
                <history v-if="$store.state.groupFSC.history" :groupCustomers="groupCustomers" @close="loadHistory"></history>
            </v-container>

        </v-card>
    </v-container>
</template>

<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
import rename from './../Modals/Catalogs/InvoiceGroupFSC/RenameInvoiceFSC.vue';
import history from './../Modals/Catalogs/InvoiceGroupFSC/HistoryInvoiceFSC.vue';
import addgroup from './../Modals/Catalogs/InvoiceGroupFSC/AddGroup.vue';
export default {
    directives: { mask },
    components: {
        rename,
        history,
        addgroup
    },
    data: function () {
        return {
            terminals: [],
            terminal: [],
            customerTable: [],
            history:[],
            customers: [],
            customer: [],
            groupCustomers: [],
            group: [],
            groupHeader: [
                { text: 'GroupName', value: 'GroupName' },
                { text: 'Region Grp', value: 'InvoiceGroup' },
                { text: 'FSC', value: 'FSC' },
                { text: 'StartDate', value: 'StartDate' },
                { text: 'EndDate', value: 'EndDate' },
                { text: 'Action', value: 'Action' },
            ],
            headers: [
                { text: 'Customer', value: 'Name' },
                { text: 'Address', value: 'Address' },
                { text: 'City', value: 'City' },
                { text: 'Province', value: 'Province' },
                { text: 'PostalCode', value: 'PostalCode' },
                { text: 'Telephone', value: 'Telephone' },
                { text: 'Action', value: 'Action' },
            ]
        };
    },
    mounted() {
        this.groupCustomer();
        this.loadCustomers();
    },
    methods: {
        groupCustomer: function () {
            this.$store.state.isLoading = true;
            axios
                .get('invoice-group-customer', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.groupCustomers = response.data;
                    console.log(this.groupCustomers);
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadTerminals: function () {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('terminal/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.terminals = response.data.data;
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        loadTabls: function (){
            this.chargeData();
            this.loadHistory();
        },
        loadHistory: function () {
            var str = this.$store;
            console.log(this.group);
            if (this.group === null) {
                this.group = [];
            }
            else {

                str.state.isLoading = true;
                axios
                    .get('invoice-history-group/show/' + this.group.InvGroupID, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        this.history = response.data;
                        str.state.isLoading = false;
                    })
                    .catch(function (error) {
                        str.state.isLoading = false;
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
            }
        },
        chargeData: function () {
            var str = this.$store;
            console.log(this.group);
            if (this.group === null) {
                this.group = [];
            }
            else {
                str.state.isLoading = true;
                axios
                    .get('invoice-group-customer/customer/group/' + this.group.InvGroupID, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        this.customerTable = response.data;
                        console.log(this.customerTable);
                        str.state.isLoading = false;
                    })
                    .catch(function (error) {
                        str.state.isLoading = false;
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
            }
        },
        loadCustomers: function () {
            this.$store.state.isLoading = true;
            axios
                .get('customer/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data.data);
                    this.customers = response.data.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        validate: async function () {
            var str = this.$store;
            console.log(this.group);
            if (this.group.InvGroupID == undefined || this.group.InvGroupID == null) {
                str.dispatch('setSnackbar', {
                    color: '#e6ac00',
                    text: 'Select a Group'
                });
            } else if (this.customer.id == undefined || this.customer.id == null) {
                str.dispatch('setSnackbar', {
                    color: '#e6ac00',
                    text: 'Select a Customer'
                });
            } else {
                var exist = await this.customerTable.findIndex(x => {
                    return x.CustomerID == this.customer.id;
                });
                if (exist >= 0) {
                    str.dispatch('setSnackbar', {
                        color: '#e6ac00',
                        text: 'This Customer is already registered'
                    });
                } else {
                    console.log('Assing', exist);
                    this.addCustomer();
                }
            }
        },
        validateFSC: function () {
            var str = this.$store;
            if (this.group.InvGroupID == undefined || this.group.InvGroupID == null) {
                str.dispatch('setSnackbar', {
                    color: '#e6ac00',
                    text: 'Select a Group'
                });
            } else {
                console.log('Save FSC');
                this.changeFSC();
            }
        },
        addCustomer: function () {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                InvoiceGroup: this.group.InvGroupID
            }
            axios
                .put('customer/' + this.customer.id, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.chargeData();
                    this.customer.length = 0;
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        deleteCustomer: function (itm) {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                InvoiceGroup: null
            }
            axios
                .put('customer/' + itm.CustomerID, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.chargeData();
                    this.customer.length = 0;
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        changeFSC: function () {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                FSC: this.group.FSC
            }
            axios
                .put('invoice-group-customer/' + this.group.InvGroupID, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        deleteHistory: function(itm){
            var str = this.$store;
                    str.state.isLoading = true;
            axios
                .delete('invoice-history-group/' + itm.HistoryFscID, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.loadHistory();
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        }
    }
};
</script>

<style>
.divs {
    margin-top: 0px;
    padding-top: 0px;
}

.chps {
    width: 10px;
}
</style>
